/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Workout_Focus_LowerInputs */

const en_us2_quick_workout_focus_lower = /** @type {(inputs: Quick_Workout_Focus_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lower body`)
};

const pt_br2_quick_workout_focus_lower = /** @type {(inputs: Quick_Workout_Focus_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inferior`)
};

const es_419_quick_workout_focus_lower = /** @type {(inputs: Quick_Workout_Focus_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tren inferior`)
};

const pt_pt2_quick_workout_focus_lower = /** @type {(inputs: Quick_Workout_Focus_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inferior`)
};

const fr_fr2_quick_workout_focus_lower = /** @type {(inputs: Quick_Workout_Focus_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bas du corps`)
};

const de_de2_quick_workout_focus_lower = /** @type {(inputs: Quick_Workout_Focus_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterkörper`)
};

const it_it2_quick_workout_focus_lower = /** @type {(inputs: Quick_Workout_Focus_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parte inferiore`)
};

/**
* | output |
* | --- |
* | "Lower body" |
*
* @param {Quick_Workout_Focus_LowerInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_focus_lower = /** @type {((inputs?: Quick_Workout_Focus_LowerInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_Focus_LowerInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_focus_lower(inputs)
	if (locale === "es-419") return es_419_quick_workout_focus_lower(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_focus_lower(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_focus_lower(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_focus_lower(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_focus_lower(inputs)
	return en_us2_quick_workout_focus_lower(inputs)
});
export { quick_workout_focus_lower as "quick-workout.focus_lower" }